import { VALUELESS_OPERATORS } from './PAYLOAD_CONDITION_OPERATORS';

// A condition is only applied to the fetched events once it has a path and, unless the operator is
// valueless (exists / is null or absent), a value.
export default function isActivePayloadCondition(condition) {
  if (condition.path.trim() === '') {
    return false;
  }

  return VALUELESS_OPERATORS.includes(condition.operator) || condition.value !== '';
}
